import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { PAGE_HEADER_VERSION_CONFIG } from '../../../../layout/page/header/page-header.config';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../config/component.config';
import { ACCESS_RESTRICTION_MODAL_CONFIG } from '../../page/access/access-restriction-modal.config';
import { NCategoryHeader } from './category-header.interface';

export const CATEGORY_HEADER_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCategoryHeader.ID,
    onDemandOnly: true,
    block: {
        url: NCategoryHeader.ID,
        scope: 'website'
    },
    name: 'Category Header',
    description: 'Content block used on listing page',
    flushPrerender: true,
    fields: [
        <NICmsContentField.IField>{
            key: 'section-general',
            type: NICmsContentField.EFieldType.label,
            title: 'Category header content'
        },
        <NICmsContentField.IChoiceField>{
            key: 'header_type',
            type: NICmsContentField.EFieldType.choice,
            title: 'Header type',
            default: 'standard',
            options: [
                { key: 'standard', title: 'Standard' },
                { key: 'content', title: 'Content' }
            ]
        },
        <NICmsContentField.IField>{
            key: 'display_image',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Display image',
            default: true,
            canShow: (data: NCategoryHeader.IData) => data?.header_type === 'standard'
        },
        <NICmsContentField.IField>{
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            canShow: (data: NCategoryHeader.IData) => data?.display_image === true && data?.header_type === 'standard'
        },
        <NICmsContentField.IChoiceField>{
            key: 'image_ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Image ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-6-1',
            canShow: (data: NCategoryHeader.IData) => data?.display_image === true && data?.header_type === 'standard'
        },
        <NICmsContentField.IComponentsField>{
            key: 'category_components',
            type: NICmsContentField.EFieldType.components,
            title: 'Category Components',
            itemName: 'component',
            default: [],
            canShow: (data: NCategoryHeader.IData) => data?.header_type === 'content'
        },
        ...ACCESS_RESTRICTION_MODAL_CONFIG,
        // header
        ...PAGE_HEADER_VERSION_CONFIG,
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
